import Command from '@ckeditor/ckeditor5-core/src/command';

export default class RotateImageCommand extends Command {
    async execute(degrees) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const selectedElement = selection.getSelectedElement();

        if (selectedElement && (selectedElement.is('element', 'imageBlock') || selectedElement.is('element', 'imageInline'))) {
            const imageUrl = selectedElement.getAttribute('src');
            const img = new Image();
            img.src = imageUrl;

            await new Promise(resolve => img.onload = resolve);

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (degrees % 180 === 0 ) {
                canvas.width = img.width;
                canvas.height = img.height;
            } else {
                canvas.width = img.height;
                canvas.height = img.width;
            }

            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((degrees * Math.PI) / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);

            const rotatedImageUrl = canvas.toDataURL();

            model.change(writer => {
                writer.setAttribute('src', rotatedImageUrl, selectedElement);
                if (degrees % 180 !== 0) {
                    // Swap width and height to match the new image dimensions
                    const originalWidth = selectedElement.getAttribute('width');
                    const originalHeight = selectedElement.getAttribute('height');
                    writer.setAttribute('width', originalHeight, selectedElement);
                    writer.setAttribute('height', originalWidth, selectedElement);

                    // for style tag aspect-ratio
                    const newStyle = `aspect-ratio:${originalHeight}/${originalWidth};`;
                    writer.setAttribute('style', newStyle, selectedElement);
                    writer.setSelection(writer.createRangeIn(selectedElement));
                }
            });
        }
    }
}
